import { withAdSet } from "components/common/useAppsflyerOneLink";

/**
 * Where the map's "open the app" links go on a phone: the app's OneLink, tagged with the CTA that was tapped (`af_adset`, the same value as the
 * desktop's `utm_content`). No `deep_link_value`: the app only handles `join/<tripId>` and drops any other value, so a route-preview one would
 * open the app without the route. A route is saved on the page (useSaveRoute, a signup on a phone too), and the "saved" link is a OneLink of its own.
 *
 * `utm_content` values: cta_route, cta_myroute, cta_scratch, cta_sticky, map_logo (topbar_signup is the prototype's own top bar, not on the hub).
 * Only cta_scratch, cta_sticky and map_logo are links on a phone; the other two are saves, whose events carry the same value.
 */
export type UtmContent = "cta_route" | "cta_myroute" | "cta_scratch" | "cta_sticky" | "map_logo";

export const phoneOnelink = (base: string, content: UtmContent): string => withAdSet(base, content);
